// src/UI/Select/selectTokens.ts

const selectTokens = {
  sizes: {
    S: { height: "28px", fontSize: "14px", paddingX: "12px", gap: "8px" },
    M: { height: "34px", fontSize: "14px", paddingX: "16px", gap: "12px" },
    L: { height: "40px", fontSize: "16px", paddingX: "20px", gap: "16px" },

    F: {                           // Filter
      height: "48px",
      fontSize: "15px",
      paddingX: "12px",
      gap: "8px",
    },
  },

  /* два разных радиуса: 24 px для «чипов», 8 px для фильтра */
  borderRadius: {
    regular: "24px",
    filter: "8px",
  },
};

export default selectTokens;
  